import React, { useCallback } from 'react';
import { useGame } from '../context/GameContext.jsx';

const TopBar = () => {
  // Desestrutura as propriedades do GameContext
  const { currentCounter, currentCards } = useGame();

  // Função memorizada para renderizar o badge do contador
  const renderCounterBadge = useCallback(() => {
    // Retorna nulo se o currentCounter for nulo ou indefinido
    if (currentCounter === null || currentCounter === undefined) {
      return null;
    }

    // Caso especial para o contador 99 (infinito)
    if (currentCounter === 99) {
      return (
        <span className="badge bg-primary top-bar-counter-badge">
          <i className="fa-solid fa-infinity"></i>
        </span>
      );
    }

    // Lógica para o contador normal (não infinito)
    let badgeClass = 'bg-secondary'; // Padrão: cinza (inativo)
    const gameHasStarted = currentCards && currentCards.length > 1; // O jogo começa quando há mais de uma carta

    if (gameHasStarted) {
      if (currentCounter <= 0) {
        badgeClass = 'bg-secondary'; // Cinza se o contador for <= 0
      } else if (currentCounter <= 10) {
        badgeClass = 'bg-danger'; // Vermelho se o contador for <= 10
      } else {
        badgeClass = 'bg-primary'; // Azul se o jogo começou e contador > 10
      }
    }

    // Retorna o badge com ícone de ampulheta e o valor do contador
    return (
      <span className={`badge ${badgeClass} top-bar-counter-badge`}>
        <i className="fa-regular fa-hourglass-half me-1"></i>
        {currentCounter}
      </span>
    );
  }, [currentCounter, currentCards]); // Dependências do hook

  // Renderização do componente TopBar
  return (
    <div className="top-bar">
      <div className="top-bar-left">
        {/* Conteúdo da esquerda, se houver */}
      </div>
      <div className="top-bar-center">
        {/* Conteúdo central, se houver */}
      </div>
      <div className="top-bar-right">
        {/* Renderiza o badge do contador */}
        {renderCounterBadge()}
      </div>
    </div>
  );
};

export default TopBar;